export enum RegDStatus {
  /**
   * User is not accredited || user is accredited, but hasn't expressed interest in RegD properties
   */
  UNDEFINED = 'UNDEFINED',
  /**
   * User is accredited && has expressed interest in RegD properties
   */
  PENDING = 'PENDING',
  /**
   * User is NOT qualified for Reg D offerings after reviewing the user's account
   */
  REJECTED = 'REJECTED',
  /**
   * User IS qualified for Reg D offerings after reviewing the user's account && user want access
   */
  QUALIFIED = 'QUALIFIED',
  /**
   * User IS qualified for Reg D offerings after reviewing the user's account; however, user doesn't want access
   */
  NOT_INTERESTED = 'NOT_INTERESTED',
  /**
   * User's account is being reviewed & more action needs to be done to make a qualification decision
   */
  FOLLOW_UP = 'FOLLOW_UP',
}
